var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-scripts/~/isarray/index.js
 ** module id = 321
 ** module chunks = 0
 **/